import { Box } from "@mui/material";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import onlyGetChangedFields from "src/common/OnlyGetChangeFieldByForm";
import { useApiMutation } from "src/hooks/useApiMutation";
import type { IFairStallList, IUpdateFairStall } from "src/Utils/type";
import StallForm from "./StallForm";

type IProps = {
	defaultValues: IFairStallList;
	handleClose?: () => void;
};
const UpdateStall = ({ defaultValues, handleClose }: IProps) => {
	const {
		register,
		handleSubmit,
		setValue,
		reset,
		watch,
		formState: { dirtyFields },
	} = useForm<IUpdateFairStall>({});

	const {
		mutate: updateStall,
		isPending,
		isSuccess,
	} = useApiMutation<Record<string, any>, void>({
		method: "PATCH",
		endPoint: `/api/fair/stall/${defaultValues.fair_stall_id}`,
		invalidateQueries: [
			"FairStalls",
			"SingleStall",
			String(defaultValues.fair_stall_id),
		],
	});

	const handleUpdateStall = (data: Record<string, any>) => {
		onlyGetChangedFields({
			dirtyFields,
			formValue: data,
			handleFun: (value: IUpdateFairStall) => {
				const updateValue: any = value;

				if ("fair_stall_air_conditioned" in value) {
					updateValue.fair_stall_air_conditioned =
						value.fair_stall_air_conditioned ? 1 : 0;
				}

				updateStall({
					...updateValue,
				});
			},
		});
	};
	useEffect(() => {
		if (defaultValues) {
			const { fair_stall_air_conditioned, ...rest } = defaultValues || {};
			reset({
				...(rest as any),
				fair_stall_air_conditioned: fair_stall_air_conditioned
					? true
					: false,
			});
		}
	}, [defaultValues]);

	useEffect(() => {
		if (isSuccess) {
			handleClose();
		}
	}, [isSuccess]);
	return (
		<Box component='form' onSubmit={handleSubmit(handleUpdateStall)}>
			<StallForm
				isPending={isPending}
				register={register}
				buttonText='Update Stall'
				defaultValues={defaultValues}
				setValue={setValue}
				watch={watch}
			/>
		</Box>
	);
};

export default UpdateStall;
